import type { StatutEtape } from '@/shared/donnees/types';
import { dansLOrdre } from '@/shared/referentiel/chantier';
import { etatChaine, FOND_ETAT_CHAINE, LIBELLE_ETAT_CHAINE } from './chaine';
import { cn } from './cn';

/** Les étapes d'un chantier, un segment chacune, dans l'ordre de la chaîne. */
export function Avancement({
  etapes,
  grand = false,
  className,
}: {
  etapes: readonly {
    id: string;
    libelle: string;
    ordre: number;
    finale: boolean;
    statut: StatutEtape;
  }[];
  grand?: boolean;
  className?: string;
}) {
  const validees = etapes.filter((e) => e.statut === 'validee').length;
  return (
    <span
      className={cn('flex gap-[3px]', grand && 'gap-1', className)}
      role="img"
      aria-label={`${validees} étape${validees > 1 ? 's' : ''} validée${validees > 1 ? 's' : ''} sur ${etapes.length}`}
    >
      {dansLOrdre(etapes).map((etape) => (
        <span
          key={etape.id}
          title={`${etape.libelle} — ${LIBELLE_ETAT_CHAINE[etatChaine(etape.statut)]}`}
          className={cn(
            'rounded-full',
            grand ? 'h-2 flex-1' : 'h-1.5 w-[18px]',
            FOND_ETAT_CHAINE[etatChaine(etape.statut)]
          )}
        />
      ))}
    </span>
  );
}
